export const types = {
  RESET_CLIENT_LOCAL_FORWARDING_EDIT_FORM_DATA: 'RESET_CLIENT_LOCAL_FORWARDING_EDIT_FORM_DATA',
  SET_VALIDATION_CLIENT_LOCAL_FORWARDING_INFO: 'SET_VALIDATION_CLIENT_LOCAL_FORWARDING_INFO',
  UPDATE_CLIENT_LOCAL_FORWARDING_INFO: 'UPDATE_CLIENT_LOCAL_FORWARDING_INFO',
};
